
module Tapas.Bindings {
    export interface IBootstrapModal {
        Id: string;
        toggle: KnockoutObservable<boolean>;
    }
    export class BootstrapModal {
        public static ModalArray: Array<Bootstrap.Modal> = [];
        public static DismissonClick(params: IBootstrapModal) {
            $('body').click(function (event) {
                if ($(event.target).is(params.Id))
                    if ($(params.Id).hasClass("in"))
                        params.toggle(false);
            });
        }
        public static AutoFocus() {
            $('.modal').on('shown.bs.modal', function () {
                $(this).find('[autofocus]').focus();
            });
        }


        public init(element: HTMLElement, valueAccessor: () => IBootstrapModal, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            var params = valueAccessor();
            var modal = new Bootstrap.Modal(params.Id);
            BootstrapModal.ModalArray.push(modal);
            var modalElement = $(params.Id);
            modalElement.attr('data-backdrop', 'static');
            modalElement.attr('data-keyboard', "false");
            modalElement.attr("role", "dialog");
            BootstrapModal.DismissonClick(params);
        }

        public update(element: HTMLElement, valueAccessor: () => IBootstrapModal, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            var params = valueAccessor();
            var modal;

            for (var i = 0; i < BootstrapModal.ModalArray.length; i++) {
                if (BootstrapModal.ModalArray[i].Selector === params.Id)
                    modal = BootstrapModal.ModalArray[i];
            }
            if (modal) {
                if (params.toggle()) {
                    modal.Show();
                    BootstrapModal.AutoFocus();
                }
                else {
                    modal.Hide();
                }
            }
        }
    }
    ko.bindingHandlers['bootstrapModal'] = new BootstrapModal();
}


module Bootstrap {

    export class Modal {
        constructor(private selector: string) {
            this.Selector = selector;
        }
        public Show() {
            $(this.selector).modal('show');
            $(this.selector).focus();
            this.Active = true;
        }
        public Hide() {
            $(this.selector).modal('hide');
            this.Active = false;
        }
        public Selector: string;
        public Active = false;
    }
}
